import {Controller} from "@hotwired/stimulus"
import {Modal} from "bootstrap"

export default class extends Controller {
    connect() {
        this.modal = new Modal(this.element)
        this.modal.show()
    }

    hideBeforeRender(event) {
        console.log(
            "[remote-modal] stream:",
            event.detail.newStream?.target,
            "open:",
            this.isOpen(),
            "keepOpen:",
            this.element.dataset.keepOpen
        )

        if (event.detail.newStream["target"] === "remote_modal_body") {
            let modal = document.getElementById("remote_modal_body")
            let danger_class = modal.dataset.stream_enter_danger_class

            modal.addEventListener("animationend", function (e) {
                e.target.classList.remove(danger_class)
            })

            modal.classList.add(danger_class)
            return
        }

        if (!this.isOpen()) return

        if (this.element.dataset.keepOpen === "true") {
            console.log("[remote-modal] keeping modal open")
            return
        }

        console.log("[remote-modal] hiding modal")

        this.modal.hide()

        this.element.addEventListener(
            "hidden.bs.modal",
            event.detail.resume,
            { once: true }
        )

        const row =
            event.target.templateElement.content.firstElementChild

        if (!row) return

        const flash_class =
            row.dataset.stream_enter_flash_class

        if (!flash_class) return

        row.addEventListener(
            "animationend",
            function (e) {
                e.target.classList.remove(flash_class)
            },
            { once: true }
        )

        row.classList.add(flash_class)
    }

    isOpen() {
        return this.element.classList.contains("show")
    }
}